// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"d40b9acb","496":"1381a633"}[chunkId] + ".chunk.js";
};